import View from '../../../Core/View.js';

class MainWrapper extends View {

	static CLASS_STATE_LOCK_CONTENT = 'main-wrapper--lock-content';

	initialize() {
		this.scrollPositionBeforeOpen = 0;

		this.signals.mobileMenuOpened.add(this.lock.bind(this));
		this.signals.mobileMenuClosed.add(this.release.bind(this));
	}

	lock() {
		this.scrollPositionBeforeOpen = (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
		this.$el.addClass(MainWrapper.CLASS_STATE_LOCK_CONTENT);
	}

	release() {
		this.$el.removeClass(MainWrapper.CLASS_STATE_LOCK_CONTENT);

		// Restore original scroll position
		window.scrollTo(0, this.scrollPositionBeforeOpen);
	}
}

export default MainWrapper;


// WEBPACK FOOTER //
// ./js/Views/Templates/MainWrapper/MainWrapper.js